// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState
// } from 'react';
// import { CircularProgress, Stack } from '@mui/material';
// import Forward5Icon from '@mui/icons-material/Forward5';
// import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// import PauseIcon from '@mui/icons-material/Pause';
// import Replay5Icon from '@mui/icons-material/Replay5';
// import { VideoLoader } from 'components';
// import { useActivityConfiguration } from 'hooks/config/activityConfig';
// import LoaderSpinner from '../../../assets/images/loader.svg';
// import styled from 'styled-components';
// import { getVideoCover } from 'utils/thumbnail';
// import { TimelineState } from '@xzdarcy/react-timeline-editor';
// import { hrsToMnsToSecToMlSec } from 'utils';

// interface VideoPlayerProps {
//   isCurrentVideoEnabled: boolean;
//   showText: boolean;
//   setShowText: React.Dispatch<React.SetStateAction<boolean>>;
//   timelineState: React.RefObject<TimelineState>;
//   loading: boolean;
//   handleBackward: () => void;
//   isPlaying: boolean;
//   handlePlay: () => void;
//   handlePause: () => void;
//   handleForward: () => void;
//   videoRef: React.RefObject<HTMLVideoElement>;
//   reset: (url: string | null) => void;
// }

// const VideoPlayer = styled('video')<{ disableControl: boolean }>(
//   ({ disableControl }) => {
//     return {
//       '&::-webkit-media-controls': {
//         display: disableControl ? 'none' : 'initial'
//       },
//       background: 'linear-gradient(135deg, rgb(30, 60, 80), rgb(16, 37, 51))', // Gradient for depth
//       boxShadow:
//         '0 4px 10px rgba(16, 37, 51, 0.6), inset 0 2px 5px rgba(255, 255, 255, 0.2)', // Outer glow + inner shine
//       borderRadius: '10px', // Smooth edges
//       border: '2px solid rgba(255, 255, 255, 0.15)', // Subtle border for depth
//       padding: '5px' // Small padding
//     };
//   }
// );

// const AnnotationVideoPlayer: React.FC<VideoPlayerProps> = ({
//   isCurrentVideoEnabled,
//   showText,
//   setShowText,
//   timelineState,
//   loading,
//   isPlaying,
//   handleBackward,
//   handlePlay,
//   handlePause,
//   handleForward,
//   videoRef,
//   reset
// }) => {
//   const [cover, setCover] = useState<string>('');
//   const [isBuffering, setIsBuffering] = useState(false);
//   const playerPanel = useRef<HTMLDivElement>(null);
//   const { currentCameraId, currentCamera, videoContainerRef } =
//     useActivityConfiguration();

//   // To check bufferring
//   useEffect(() => {
//     if (!videoRef.current) return;

//     const video = videoRef.current;
//     let bufferingTimer: NodeJS.Timeout;

//     // Function to check if the video is actually buffering
//     const checkBuffering = () => {
//       if (!video.paused) {
//         // Only check buffering when video is playing
//         // Check if video is actually stuck buffering
//         if (video.currentTime > 0) {
//           const buffered = video.buffered;
//           if (buffered.length > 0) {
//             const currentBuffered = buffered.end(buffered.length - 1);
//             // Only show buffering if we're close to the end of buffered content
//             if (currentBuffered - video.currentTime < 0.5) {
//               // Half second threshold
//               setIsBuffering(true);
//             } else {
//               setIsBuffering(false);
//             }
//           }
//         }
//       } else {
//         setIsBuffering(false); // Not buffering if video is paused
//       }
//     };

//     // When video is waiting for more data
//     const handleWaiting = () => {
//       // Add a small delay before showing the buffer to prevent flashing
//       bufferingTimer = setTimeout(() => {
//         checkBuffering();
//       }, 150);
//     };

//     // When video starts playing
//     const handlePlaying = () => {
//       clearTimeout(bufferingTimer);
//       setIsBuffering(false);
//     };

//     // When video has loaded enough to play through
//     const handleCanPlayThrough = () => {
//       clearTimeout(bufferingTimer);
//       setIsBuffering(false);
//     };

//     // Add all event listeners
//     video.addEventListener('waiting', handleWaiting);
//     video.addEventListener('playing', handlePlaying);
//     video.addEventListener('canplaythrough', handleCanPlayThrough);
//     video.addEventListener('seeked', () => setIsBuffering(false));
//     video.addEventListener('pause', () => setIsBuffering(false));

//     // Cleanup
//     return () => {
//       clearTimeout(bufferingTimer);
//       video.removeEventListener('waiting', handleWaiting);
//       video.removeEventListener('playing', handlePlaying);
//       video.removeEventListener('canplaythrough', handleCanPlayThrough);
//       video.removeEventListener('seeked', () => setIsBuffering(false));
//       video.removeEventListener('pause', () => setIsBuffering(false));
//     };
//   }, [videoRef.current]);

//   // Remove the separate currentTime and duration state
//   const [videoMetadata, setVideoMetadata] = useState<{
//     currentTime: number;
//     duration: number;
//   }>({ currentTime: 0, duration: 0 });

//   // Memoized time update handler
//   const handleTimeUpdate = useCallback(() => {
//     if (videoRef.current) {
//       setVideoMetadata({
//         currentTime: videoRef.current.currentTime,
//         duration: videoRef.current.duration || 0
//       });
//     }
//   }, [videoRef]);

//   // Use useEffect to set up event listeners
//   useEffect(() => {
//     const videoElement = videoRef.current;
//     if (!videoElement) return;

//     videoElement.addEventListener('timeupdate', handleTimeUpdate);
//     videoElement.addEventListener('loadedmetadata', handleTimeUpdate);

//     return () => {
//       videoElement.removeEventListener('timeupdate', handleTimeUpdate);
//       videoElement.removeEventListener('loadedmetadata', handleTimeUpdate);
//     };
//   }, [handleTimeUpdate, videoRef]);

//   // Memoized time display
//   const formattedTime = useMemo(() => {
//     return {
//       current: hrsToMnsToSecToMlSec(videoMetadata.currentTime),
//       total: hrsToMnsToSecToMlSec(videoMetadata.duration)
//     };
//   }, [videoMetadata.currentTime, videoMetadata.duration]);

//   useEffect(() => {
//     if (!currentCamera?.lowres_url) {
//       setShowText(true);
//     } else {
//       reset(currentCamera?.lowres_url);
//       getVideoCover(currentCamera.lowres_url).then(cover => {
//         setCover(cover);
//       });
//       setShowText(false);
//     }
//   }, [currentCamera?.lowres_url]);

//   const handlePlaybackRateChange = (event: any) => {
//     const playbackRate = parseFloat(event);
//     if (videoRef.current) {
//       videoRef.current.playbackRate = playbackRate;
//     }
//   };

//   useEffect(() => {
//     if (currentCameraId) {
//       timelineState && timelineState?.current?.setTime(0);
//       handlePlaybackRateChange(1);
//     }
//   }, [currentCameraId]);

//   console.log(videoRef?.current?.currentTime, 'CURRENTTIME');

//   return (
//     <Stack spacing={2} direction={'column'}>
//       <div
//         id="videoContainer"
//         ref={videoContainerRef}
//         style={{
//           position: 'relative'
//         }}
//       >
//         {!isCurrentVideoEnabled && (
//           <div
//             style={{
//               display: 'flex',
//               justifyContent: 'center',
//               position: 'fixed',
//               zIndex: 100,
//               top: '50%',
//               left: '40%',
//               border: '1px solid orange',
//               borderRadius: '10px',
//               padding: '10px',
//               backgroundColor: '#FFA50025',
//               color: 'black'
//             }}
//           >
//             Annotation is being performed at another device. kindly come back
//             after some time.
//           </div>
//         )}
//         {showText ? (
//           <>
//             <VideoLoader height={400} />
//             <div
//               style={{
//                 position: 'absolute',
//                 top: '46%',
//                 left: '50%',
//                 transform: 'translate(-50%, -50%)',
//                 gap: 0,
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 height: '800px',
//                 width: '1000px'
//               }}
//             >
//               <img
//                 src={LoaderSpinner}
//                 alt="loader"
//                 style={{ width: '80px', height: '80px' }}
//               />
//               <h3
//                 style={{
//                   color: 'white',
//                   fontSize: 18,
//                   margin: 0,
//                   padding: 0
//                 }}
//               >
//                 Processing the video. This will take some time, please wait.
//               </h3>
//             </div>
//           </>
//         ) : (
//           <>
//             <VideoPlayer
//               id="video"
//               ref={videoRef}
//               style={{
//                 width: '100%',
//                 height: 'auto',
//                 maxHeight: '50vh'
//               }}
//               poster={
//                 cover ||
//                 'https://cdn.dribbble.com/users/17914/screenshots/4902225/media/0d6d47739dae97adc81ca7076ee56cc9.png'
//               }
//               controlsList="nodownload"
//               disablePictureInPicture
//               muted
//               src={currentCamera?.lowres_url || ''}
//               disableControl={false}
//             />
//             {currentCamera?.lowres_url && cover && (
//               <div
//                 style={{
//                   // marginLeft: '10px',
//                   // position: 'absolute',
//                   // gap: '10px',
//                   marginTop: '-25px',
//                   marginBottom: '10px',
//                   display: 'flex',
//                   justifyContent: 'center'
//                 }}
//               >
//                 {/* Time Display */}
//                 <div style={{ fontWeight: 'bold', fontSize: '12px' }}>
//                   {formattedTime.current} / {formattedTime.total}
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//         {isBuffering && (
//           <div
//             className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50"
//             style={{
//               height: '95.5%'
//             }}
//           >
//             <div className="animate-spin rounded-full h-4 w-12 border-t-2 border-b-2 border-white"></div>
//           </div>
//         )}
//         {loading && videoRef.current && videoRef.current?.currentTime > 0 && (
//           <CircularProgress
//             size={60}
//             sx={{
//               position: 'absolute',
//               top: '50%',
//               left: '50%',
//               transform: 'translate(-50%, -50%)'
//             }}
//           />
//         )}
//         <div
//           className="player-panel"
//           id="player-ground-1"
//           ref={playerPanel}
//           style={{
//             position: 'relative', // Enables absolute positioning for child elements
//             display: 'flex',
//             alignItems: 'center',
//             background:
//               'linear-gradient(135deg, rgb(30, 60, 80), rgb(16, 37, 51))',
//             padding: '10px 15px',
//             boxShadow:
//               '0 4px 10px rgba(16, 37, 51, 0.6), inset 0 2px 5px rgba(255, 255, 255, 0.3)',
//             borderRadius: '5px',
//             border: '2px solid rgba(255, 255, 255, 0.2)',
//             width: '100%', // Ensures full width
//             height: '30px' // Set a fixed height to help with centering
//           }}
//         >
//           {/* Left: Playback Speed Selector */}
//           {currentCamera?.lowres_url && cover && (
//             <div style={{ display: 'flex', alignItems: 'center' }}>
//               <label
//                 htmlFor="playbackRate"
//                 style={{ fontWeight: 'bold', fontSize: '12px', color: 'white' }}
//               >
//                 Playback Speed:{' '}
//               </label>
//               <select
//                 id="playbackRate"
//                 onChange={e => handlePlaybackRateChange(e.target.value)}
//                 style={{
//                   borderRadius: '10px',
//                   background: '#80808040',
//                   width: '100px',
//                   color: 'white',
//                   marginLeft: '5px'
//                 }}
//                 value={videoRef?.current?.playbackRate || 1}
//               >
//                 {[0.3, 0.5, 1, 1.5, 2].map(speed => (
//                   <option
//                     key={speed}
//                     value={speed}
//                     style={{
//                       borderRadius: '10px',
//                       backgroundColor: 'white',
//                       color: 'black'
//                     }}
//                   >
//                     {speed}x
//                   </option>
//                 ))}
//               </select>
//             </div>
//           )}

//           {/* Center: Video Control Buttons */}
//           <div
//             style={{
//               position: 'absolute',
//               left: '50%',
//               transform: 'translateX(-50%)', // Centers it exactly in the middle
//               display: 'flex',
//               alignItems: 'center',
//               gap: '15px'
//             }}
//           >
//             <Replay5Icon
//               style={{ cursor: 'pointer', fill: 'white' }}
//               onClick={handleBackward}
//             />
//             <PlayArrowIcon
//               style={{
//                 cursor: 'pointer',
//                 fill: 'white',
//                 display: !isPlaying ? 'block' : 'none'
//               }}
//               onClick={handlePlay}
//             />
//             <PauseIcon
//               style={{
//                 cursor: 'pointer',
//                 fill: 'white',
//                 display: isPlaying ? 'block' : 'none'
//               }}
//               onClick={handlePause}
//             />
//             <Forward5Icon
//               style={{ cursor: 'pointer', fill: 'white' }}
//               onClick={handleForward}
//             />
//           </div>
//         </div>
//       </div>
//     </Stack>
//   );
// };

// export default AnnotationVideoPlayer;

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { CircularProgress, Stack } from '@mui/material';
import Forward5Icon from '@mui/icons-material/Forward5';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import Replay5Icon from '@mui/icons-material/Replay5';
import { VideoLoader } from 'components';
import { useActivityConfiguration } from 'hooks/config/activityConfig';
import LoaderSpinner from '../../../assets/images/loader.svg';
import styled from 'styled-components';
import { getVideoCover } from 'utils/thumbnail';
import { TimelineState } from '@xzdarcy/react-timeline-editor';
import { hrsToMnsToSecToMlSec } from 'utils';

interface VideoPlayerProps {
  isCurrentVideoEnabled: boolean;
  showText: boolean;
  setShowText: React.Dispatch<React.SetStateAction<boolean>>;
  timelineState: React.RefObject<TimelineState>;
  loading: boolean;
  handleBackward: () => void;
  isPlaying: boolean;
  handlePlay: () => void;
  handlePause: () => void;
  handleForward: () => void;
  videoRef: React.RefObject<HTMLVideoElement>;
  reset: (url: string | null) => void;
}

const VideoPlayer = styled('video')<{ disableControl: boolean }>(
  ({ disableControl }) => {
    return {
      '&::-webkit-media-controls': {
        display: disableControl ? 'none' : 'initial'
      },
      background: 'linear-gradient(135deg, rgb(30, 60, 80), rgb(16, 37, 51))', // Gradient for depth
      boxShadow:
        '0 4px 10px rgba(16, 37, 51, 0.6), inset 0 2px 5px rgba(255, 255, 255, 0.2)', // Outer glow + inner shine
      borderRadius: '10px', // Smooth edges
      border: '2px solid rgba(255, 255, 255, 0.15)', // Subtle border for depth
      padding: '5px' // Small padding
    };
  }
);

const AnnotationVideoPlayer: React.FC<VideoPlayerProps> = ({
  isCurrentVideoEnabled,
  showText,
  setShowText,
  timelineState,
  loading,
  isPlaying,
  handleBackward,
  handlePlay,
  handlePause,
  handleForward,
  videoRef,
  reset
}) => {
  const [cover, setCover] = useState<string>('');
  const [isBuffering, setIsBuffering] = useState(false);
  const playerPanel = useRef<HTMLDivElement>(null);
  const { currentCameraId, currentCamera, videoContainerRef } =
    useActivityConfiguration();

  // Improved current time tracking
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);

  // Improved time update handler
  useEffect(() => {
    const videoElement = videoRef.current;
    if (!videoElement) return;

    const handleTimeUpdate = () => {
      setCurrentTime(videoElement.currentTime);
    };

    const handleLoadedMetadata = () => {
      setDuration(videoElement.duration);
    };

    videoElement.addEventListener('timeupdate', handleTimeUpdate);
    videoElement.addEventListener('loadedmetadata', handleLoadedMetadata);

    return () => {
      videoElement.removeEventListener('timeupdate', handleTimeUpdate);
      videoElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
    };
  }, [videoRef]);

  // Memoized time display
  const formattedTime = useMemo(() => {
    return {
      current: hrsToMnsToSecToMlSec(currentTime),
      total: hrsToMnsToSecToMlSec(duration)
    };
  }, [currentTime, duration]);

  // Buffering effect
  useEffect(() => {
    if (!videoRef.current) return;

    const video = videoRef.current;
    let bufferingTimer: NodeJS.Timeout;

    const checkBuffering = () => {
      if (!video.paused) {
        if (video.currentTime > 0) {
          const buffered = video.buffered;
          if (buffered.length > 0) {
            const currentBuffered = buffered.end(buffered.length - 1);
            if (currentBuffered - video.currentTime < 0.5) {
              setIsBuffering(true);
            } else {
              setIsBuffering(false);
            }
          }
        }
      } else {
        setIsBuffering(false);
      }
    };

    const handleWaiting = () => {
      bufferingTimer = setTimeout(() => {
        checkBuffering();
      }, 150);
    };

    const handlePlaying = () => {
      clearTimeout(bufferingTimer);
      setIsBuffering(false);
    };

    const handleCanPlayThrough = () => {
      clearTimeout(bufferingTimer);
      setIsBuffering(false);
    };

    video.addEventListener('waiting', handleWaiting);
    video.addEventListener('playing', handlePlaying);
    video.addEventListener('canplaythrough', handleCanPlayThrough);
    video.addEventListener('seeked', () => setIsBuffering(false));
    video.addEventListener('pause', () => setIsBuffering(false));

    return () => {
      clearTimeout(bufferingTimer);
      video.removeEventListener('waiting', handleWaiting);
      video.removeEventListener('playing', handlePlaying);
      video.removeEventListener('canplaythrough', handleCanPlayThrough);
      video.removeEventListener('seeked', () => setIsBuffering(false));
      video.removeEventListener('pause', () => setIsBuffering(false));
    };
  }, [videoRef.current]);

  useEffect(() => {
    if (!currentCamera?.lowres_url) {
      setShowText(true);
    } else {
      reset(currentCamera?.lowres_url);
      getVideoCover(currentCamera.lowres_url).then(cover => {
        setCover(cover);
      });
      setShowText(false);
    }
  }, [currentCamera?.lowres_url]);

  const handlePlaybackRateChange = (event: any) => {
    const playbackRate = parseFloat(event);
    if (videoRef.current) {
      videoRef.current.playbackRate = playbackRate;
    }
  };

  useEffect(() => {
    if (currentCameraId) {
      timelineState && timelineState?.current?.setTime(0);
      handlePlaybackRateChange(1);
    }
  }, [currentCameraId]);

  return (
    <Stack spacing={2} direction={'column'}>
      <div
        id="videoContainer"
        ref={videoContainerRef}
        style={{
          position: 'relative'
        }}
      >
        {!isCurrentVideoEnabled && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              position: 'fixed',
              zIndex: 100,
              top: '50%',
              left: '40%',
              border: '1px solid orange',
              borderRadius: '10px',
              padding: '10px',
              backgroundColor: '#FFA50025',
              color: 'black'
            }}
          >
            Annotation is being performed at another device. Kindly come back
            after some time.
          </div>
        )}
        {showText ? (
          <>
            <VideoLoader height={400} />
            <div
              style={{
                position: 'absolute',
                top: '46%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                gap: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '800px',
                width: '1000px'
              }}
            >
              <img
                src={LoaderSpinner}
                alt="loader"
                style={{ width: '80px', height: '80px' }}
              />
              <h3
                style={{
                  color: 'white',
                  fontSize: 18,
                  margin: 0,
                  padding: 0
                }}
              >
                Processing the video. This will take some time, please wait.
              </h3>
            </div>
          </>
        ) : (
          <>
            <VideoPlayer
              id="video"
              ref={videoRef}
              style={{
                width: '100%',
                height: 'auto',
                maxHeight: '50vh'
              }}
              poster={
                cover ||
                'https://cdn.dribbble.com/users/17914/screenshots/4902225/media/0d6d47739dae97adc81ca7076ee56cc9.png'
              }
              controlsList="nodownload"
              disablePictureInPicture
              muted
              src={currentCamera?.lowres_url || ''}
              disableControl={false}
            />
            {currentCamera?.lowres_url && cover && (
              <div
                style={{
                  marginTop: '-25px',
                  marginBottom: '10px',
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                {/* Time Display */}
                <div style={{ fontWeight: 'bold', fontSize: '12px' }}>
                  {formattedTime.current} / {formattedTime.total}
                </div>
              </div>
            )}
          </>
        )}
        {isBuffering && (
          <div
            className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50"
            style={{
              height: '95.5%'
            }}
          >
            <div className="animate-spin rounded-full h-4 w-12 border-t-2 border-b-2 border-white"></div>
          </div>
        )}
        {loading && videoRef.current && videoRef.current?.currentTime > 0 && (
          <CircularProgress
            size={60}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)'
            }}
          />
        )}
        <div
          className="player-panel"
          id="player-ground-1"
          ref={playerPanel}
          style={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            background:
              'linear-gradient(135deg, rgb(30, 60, 80), rgb(16, 37, 51))',
            padding: '10px 15px',
            boxShadow:
              '0 4px 10px rgba(16, 37, 51, 0.6), inset 0 2px 5px rgba(255, 255, 255, 0.3)',
            borderRadius: '5px',
            border: '2px solid rgba(255, 255, 255, 0.2)',
            width: '100%',
            height: '30px'
          }}
        >
          {/* Left: Playback Speed Selector */}
          {currentCamera?.lowres_url && cover && (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <label
                htmlFor="playbackRate"
                style={{ fontWeight: 'bold', fontSize: '12px', color: 'white' }}
              >
                Playback Speed:{' '}
              </label>
              <select
                id="playbackRate"
                onChange={e => handlePlaybackRateChange(e.target.value)}
                style={{
                  borderRadius: '10px',
                  background: '#80808040',
                  width: '100px',
                  color: 'white',
                  marginLeft: '5px'
                }}
                value={videoRef?.current?.playbackRate || 1}
              >
                {[0.3, 0.5, 1, 1.5, 2].map(speed => (
                  <option
                    key={speed}
                    value={speed}
                    style={{
                      borderRadius: '10px',
                      backgroundColor: 'white',
                      color: 'black'
                    }}
                  >
                    {speed}x
                  </option>
                ))}
              </select>
            </div>
          )}

          {/* Center: Video Control Buttons */}
          <div
            style={{
              position: 'absolute',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Replay5Icon
              style={{ cursor: 'pointer', fill: 'white' }}
              onClick={handleBackward}
            />
            <PlayArrowIcon
              style={{
                cursor: 'pointer',
                fill: 'white',
                display: !isPlaying ? 'block' : 'none'
              }}
              onClick={handlePlay}
            />
            <PauseIcon
              style={{
                cursor: 'pointer',
                fill: 'white',
                display: isPlaying ? 'block' : 'none'
              }}
              onClick={handlePause}
            />
            <Forward5Icon
              style={{ cursor: 'pointer', fill: 'white' }}
              onClick={handleForward}
            />
          </div>
        </div>
      </div>
    </Stack>
  );
};

export default AnnotationVideoPlayer;
